import { WidgetType } from 'domain/entity/widget';
import WidgetData, { Color, Icon, Period, WidgetDataAvailability, WidgetDescription } from 'domain/entity/widgetData';

export type SingleKPIWidgetData = WidgetData & {
    units: string;
    value: number;
    color: Color;
    icon: Icon;
    comparison: SingleKPIComparison;
    text: string;
};

export type SingleKPIComparison = {
    enabled: boolean;
    period: Period;
    color: Color;
    value: number;
    showAsPercentage: boolean;
};

class SingleKPIData implements SingleKPIWidgetData {
    type = WidgetType.SINGLE_KPI;

    constructor(
        readonly value: number,
        readonly units: string,
        readonly dataAvailability: WidgetDataAvailability,
        readonly description: WidgetDescription,
        readonly color: Color,
        readonly icon: Icon,
        readonly comparison: SingleKPIComparison,
        public text: string
    ) {}
}

export default SingleKPIData;
